import styles from './sociogram-surveys-list.module.scss'
import { useTranslation } from 'react-i18next'
import AlertComponent from '@BUP/components/Generics/Alert'
import CollapsePanel from '..'
import SociogramTable from '@BUP/components/Generics/Table/SociogramTable'
import { useGetSociogram } from '@BUP/hooks/Sociogram/useGetSociogram'
import { useGetSurveysBySociogramId } from '@BUP/hooks/Sociogram/useGetSurveysBySociogramId'
import { useGetOrganizationRecommendations } from '@BUP/hooks/Sociogram/recommendations/useGetOrganizationRecommendations'
import FinishSociogramModal from './finish-sociogram-modal'
import ButtonComponent from '../../Buttons/button-component'
import { ReloadOutlined } from '@ant-design/icons'
import { useGetParticipantsTerminatedsBySociogram } from '@BUP/hooks/Sociogram/participantsTerminated/useGetParticipantsTerminatedBySociogram'
import { Skeleton } from 'antd'

const SociogramSurveysList = ({ events, selectedEvent }) => {
  const i18n = useTranslation()
  const sociogramId = selectedEvent.activityId

  const { participantsTerminated, isLoadingParticipantsTerminated } = useGetParticipantsTerminatedsBySociogram(sociogramId)

  const { data: surveysData, isLoading: isLoadingDataSurveys, error: errorDataSurveys, getSurveys } = useGetSurveysBySociogramId(sociogramId)

  const {
    isLoadingSociogram,
    dataSociogram,
    getSociogram,
    errorSociogram,
    isFetchingSociogram
  } = useGetSociogram(sociogramId)

  const {
    isLoadingRecommendations,
    isFetchingRecommendations,
    dataRecommendations,
    errorResultRecommendations
  } = useGetOrganizationRecommendations()

  const isTableLoading =
    isLoadingSociogram ||
    isFetchingSociogram ||
    isLoadingDataSurveys ||
    isLoadingRecommendations ||
    isFetchingRecommendations ||
    isLoadingParticipantsTerminated

  const reloadSurveys = async () => {
    await getSurveys()
  }

  const reloadSociogram = async () => {
    await getSociogram()
  }

  if (isTableLoading) {
    return (
      <div className={styles.surveys_container}>
        <div className={styles.collapse_wrapper}>
          <CollapsePanel
            id={sociogramId}
            label={
              <h5 className={styles.collapse_label}>
                {i18n.t('pages.data.sociogram.activeSociogramEce.sociogramSurveysList.collapseTitle')}
              </h5>
            }
            shadow
            borderBottom
            isOpenCollapse
          >
            <div className={styles.table_loading_wrapper}>
              <Skeleton active paragraph={{ rows: 4 }} />
            </div>
          </CollapsePanel>
        </div>
      </div>
    )
  }

  if (errorSociogram) {
    return (
      <div className={styles.error_wrapper}>
        <AlertComponent
          message={i18n.t('pages.data.sociogram.activeSociogramEce.sociogramSurveysList.errorSociogram')}
          type='error'
        />
        <ButtonComponent
          buttonText={i18n.t('common.resources.generic.actions.reload.generic')}
          size='small'
          icon={<ReloadOutlined />}
          onClick={reloadSociogram}
        />
      </div>
    )
  }

  if (!dataSociogram || dataSociogram.length === 0) {
    return (
      <div className={styles.error_wrapper}>
        <AlertComponent
          message={i18n.t('pages.data.sociogram.activeSociogramEce.sociogramSurveysList.errorSociogram')}
          type='error'
        />
      </div>
    )
  }

  if (errorDataSurveys) {
    return (
      <div className={styles.error_wrapper}>
        <AlertComponent
          message={i18n.t('pages.data.sociogram.activeSociogramEce.sociogramSurveysList.errorSurveys')}
          type='error'
        />
        <ButtonComponent
          buttonText={i18n.t('common.resources.generic.actions.reload.surveys')}
          size='small'
          icon={<ReloadOutlined />}
          onClick={reloadSurveys}
        />
      </div>
    )
  }

  if (!surveysData || surveysData.length === 0) {
    return (
      <div className={styles.error_wrapper}>
        <AlertComponent
          message={i18n.t('pages.data.sociogram.activeSociogramEce.sociogramSurveysList.errorSurveys')}
          type='error'
        />
      </div>
    )
  }

  const combinedDataSurveys = surveysData.map((survey) => {
    const resource =
      dataRecommendations?.find(
        (result) => result.resultId === survey.results?.[0]?.id
      ) || null

    const participantsTerminatedSurvey =
      participantsTerminated?.find((elem) => elem.surveyId === survey.id)?.participantsTerminated || []

    return {
      ...survey,
      resource,
      participantsTerminated: participantsTerminatedSurvey
    }
  })

  const sociogram = dataSociogram?.[0]

  if (!sociogram) return null

  const { isDone: isDoneSociogram } = sociogram

  return (
    <div
      className={styles.surveys_container}
      data-test='surveys-list-container'
    >
      <div className={styles.collapse_wrapper}>
        <CollapsePanel
          id={sociogramId}
          label={
            <h5 className={styles.collapse_label}>{i18n.t('pages.data.sociogram.activeSociogramEce.sociogramSurveysList.collapseTitle')}</h5>
          }
          shadow
          borderBottom
          isOpenCollapse
        >
          <div
            className={styles.table_wrapper}
            data-test='surveys-list-table-wrapper'
          >
            <SociogramTable
              error={errorSociogram || errorResultRecommendations}
              loading={false}
              surveysData={combinedDataSurveys}
              selectedEvent={selectedEvent}
            />
          </div>
        </CollapsePanel>
      </div>
      <FinishSociogramModal
        sociogramId={sociogramId}
        isDoneSociogram={isDoneSociogram}
        getSociogram={getSociogram}
        events={events}
      />
    </div>
  )
}

export default SociogramSurveysList
